import { Component, Prop, Watch } from 'vue-property-decorator';
import uuid from 'uuid/v4';
import BaseComponent from '@/components/base/BaseComponent';

@Component({})
export default class TermsAndPrivacyComponent extends BaseComponent {

  @Prop(Boolean) public dialogProp!: boolean;
  @Prop(Boolean) public persistent!: boolean;
  @Prop(Boolean) public closeButton!: boolean;

  public modalId: string = '';
  public dialog: boolean = false;

  public created() {
    this.modalId = 'modal' + uuid();
  }

  public mounted() {
    const that = this;
    document.addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        that.closeDialog();
      }
    });

    this.dialog = this.dialogProp;
  }

  @Watch('dialog')
  public onDialogChanged(newVal: boolean, oldVal: boolean): void {
    if (!newVal) {
      this.closeDialog();
    }
  }

  public closeDialog(): void {
    this.$emit('dialogClosed');
  }

  public dialogMaskClicked() {
    if (!this.persistent) {
      this.closeDialog();
    }
  }
}
